import React, { useState } from "react";
import styles from "./styles.module.scss";
import { localizedStrings } from "src/localization/index.jsx";
import { Image } from "react-bootstrap";
import ZoomLogo from "src/legacy/images/zoom_logo.png";
import BackButton from "src/legacy/components/BackButton";
import _ from "lodash";
import SwitchButton from "src/components/switchButton";

export const ZoomSideBar = (props) => {
  const localizedIntegrations = localizedStrings.components.integrations;
  const localizedZoom = localizedStrings.components.integrations.zoom;
  const localizedCommons = localizedStrings.commons;
  const localizedIntgerationActions = localizedStrings.components.integrations.actions;

  return (
    <div className={styles.sideBar}>
      <BackButton
        className={styles.back}
        title={localizedCommons.actions.back}
        onClick={() => { props.handleIntegrationsBackButton();}}
      />
      <div className={styles.headerContainer}>
        <div className={styles.heading}>
          <Image src={ZoomLogo} />
          <h2 className={styles.name}>{localizedZoom.title}</h2>
          <p className={styles.description}>{localizedZoom.sub_text}</p>
        </div>

        <div className={styles.actions}>
          {((_.size(_.get(props, "integration")) > 0 &&
            !props.isAuthenticated) ||
            (_.size(_.get(props, "integration")) > 0 &&
              props.isTokenExpired)) && props.canEdit() && (
            <button
              onClick={() => props.handleAuthenticate()}
              disabled={props.authenticating}
              className={styles.button}
            >
              {props.authenticating
                ? localizedIntgerationActions.authenticating + "..."
                : localizedIntgerationActions.re_authenticate}
            </button>
          )}

          {_.size(_.get(props, "integration")) == 0 &&
            !props.isAuthenticated && props.canEdit() && (
              <button
                onClick={() => props.handleAuthenticate()}
                disabled={props.authenticating}
                className={styles.button}
              >
                {props.authenticating &&
                  localizedIntgerationActions.authenticating + "..."}
                {!props.authenticating &&
                  localizedIntgerationActions.authenticate}
              </button>
            )}

          {_.size(_.get(props, "integration")) > 0 &&
            props.isAuthenticated &&
            !props.isTokenExpired && props.canEdit() && (
              <button
                className={styles.button}
                disabled={props.deactivating}
                onClick={() => props._handleDeactivateClicked()}
              >
                {props.deactivating &&
                  `${localizedIntgerationActions.deactivating}...`}
                {!props.deactivating && localizedIntgerationActions.deactivate}
              </button>
            )}
        </div>
      </div>
    </div>
  );
};
